export enum SessionIntention__CreatedBy {
  CLIENT = 'CLIENT',
  PROVIDER = 'PROVIDER',
}

export enum SessionIntention__EditedBy {
  CLIENT = 'CLIENT',
  PROVIDER = 'PROVIDER',
}
